export default {
	// global targets ALL components
	AJAX_SPINNER: 'ajaxSpinner',
	BUTTON: 'button',
	CALENDAR_INPUT: 'calendarInput',
	CHECKBOX: 'checkbox',
	COLLAPSIBLE_SECTION: 'collapsibleSection',
	CONFIRMATION_BUTTON: 'confirmationButton',
	DELAYED_TEXT_AREA: 'delayedTextArea',
	DELAYED_TEXT_INPUT: 'delayedTextInput',
	FILE_UPLOAD: 'fileUpload',
	FORM_ERROR: 'formError',
	GLOBAL: 'global',
	INPUT_CONTAINER: 'inputContainer',
	LINK: 'link',
	PLAIN_TEXT: 'plainText',
	POP_OVER: 'popOver',
	POPUP_WINDOW: 'popupWindow',
	SEGMENTED_BUTTON: 'segmentedButton',
	SELECT_INPUT: 'selectInput',
	TABLE: 'table',
	TEXT_AREA: 'textArea',
	TEXT_INPUT: 'textInput',
};
